"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Box_1 = __importDefault(require("@mui/material/Box"));
var Typography_1 = __importDefault(require("@mui/material/Typography"));
var Link_1 = __importDefault(require("@mui/material/Link"));
var Lang_js_1 = require("../Lang.js");
var CLIENT_TIPS = [
    'Gmail — look in the Promotions tab and in Spam. If you find it in Spam, open it and choose “Not spam”.',
    'Outlook or Hotmail — look in the Junk Email folder, and in the “Other” tab if you use Focused Inbox. If you find it in Junk, choose “Not junk”.',
    'Apple Mail or iCloud Mail — look in the Junk folder.',
    'Yahoo or AOL — look in the Spam folder.',
    'Proton Mail — look in the Spam folder.',
    'A work or school address — your organisation may be holding it in a quarantine or blocked-senders digest. Your IT team can release it.',
];
var Heading = function (_a) {
    var children = _a.children;
    return (react_1.default.createElement(Typography_1.default, { sx: { fontSize: '15px', fontWeight: 700, mt: 1.5, mb: 0.5 } }, children));
};
var FindConfirmationEmail = function (_a) {
    var hints = _a.hints;
    var fromName = hints.from_name, fromEmail = hints.from_email, subject = hints.subject, resendUrl = hints.resend_url;
    // MSIA sends from several addresses on one domain (audience default for confirmations,
    // listmaster for Loving Each Day, webteam). Allowlisting only the confirmation sender would
    // leave the mail a member actually reads still going to spam. Mirrors the Blade partial.
    var domain = fromEmail && fromEmail.includes('@') ? fromEmail.split('@').pop() : 'msia.org';
    // Assembled as one paragraph, matching the Blade partial: a searchable sender and subject beat
    // any amount of prose about spam folders, so they lead.
    var identity = fromName && fromEmail
        ? (0, Lang_js_1.__)('It comes from :name, at :address.').replace(':name', fromName).replace(':address', fromEmail)
        : fromName
            ? (0, Lang_js_1.__)('It comes from :name.').replace(':name', fromName)
            : (0, Lang_js_1.__)('It comes from our email provider, Mailchimp, rather than from an MSIA address.');
    return (react_1.default.createElement(Box_1.default, { sx: { fontSize: '14px', lineHeight: 1.6 } },
        react_1.default.createElement(Heading, null, (0, Lang_js_1.__)('What the email looks like')),
        react_1.default.createElement(Typography_1.default, { sx: { fontSize: '14px', lineHeight: 1.6 } },
            identity,
            subject ? " ".concat((0, Lang_js_1.__)('The subject line is “:subject”.').replace(':subject', subject)) : '',
            fromEmail
                ? " ".concat((0, Lang_js_1.__)('Searching your mail for :address is the quickest way to find it wherever it landed.').replace(':address', fromEmail))
                : ''),
        react_1.default.createElement(Heading, null, (0, Lang_js_1.__)('Where it may be hiding')),
        react_1.default.createElement(Box_1.default, { component: "ul", sx: { m: 0, pl: 2.5 } }, CLIENT_TIPS.map(function (tip) { return (react_1.default.createElement(Box_1.default, { component: "li", key: tip, sx: { mb: 0.5 } }, (0, Lang_js_1.__)(tip))); })),
        react_1.default.createElement(Heading, null, (0, Lang_js_1.__)('So it does not happen again')),
        react_1.default.createElement(Typography_1.default, { sx: { fontSize: '14px', lineHeight: 1.6 } }, fromEmail
            ? (0, Lang_js_1.__)('Add :address to your contacts or to your safe-senders list. MSIA sends from more than one address at :domain, so allowing the whole domain is more reliable — on a work address, your IT team can do that.')
                .replace(':address', fromEmail)
                .replace(':domain', domain)
            : (0, Lang_js_1.__)('Add the sender to your contacts or to your safe-senders list. MSIA sends from more than one address at :domain, so allowing the whole domain is more reliable — on a work address, your IT team can do that.')
                .replace(':domain', domain)),
        resendUrl && (react_1.default.createElement(Typography_1.default, { sx: { fontSize: '14px', mt: 1.5 } },
            react_1.default.createElement(Link_1.default, { href: resendUrl, target: "_blank", rel: "noopener noreferrer", underline: "always" }, (0, Lang_js_1.__)('Still cannot find it? Confirm your subscription here — it takes one click.'))))));
};
exports.default = FindConfirmationEmail;
